module.exports = __webpack_public_path__ + "static/a5bef9153b8b27c3717167079896413a43ada3e371aad72961012cf06d8a5e48-c65ab75fd102b2c0540ed008150a0d2d.png";